export const GET_ACTIVITIES_PATH = 'api/landlord/activities';